<template>
	<div class="flex-column">
		<div class="full-height overflow-y-auto pb-50 mb-10">
			<div>
				<label class="h6 display-block ">
					{{ item.work_name }}
				</label>

				<div class="mt-10 box pa-10 radius-10">
					{{ item.sDate }} ~ {{ item.eDate }}
				</div>

				<div
					class="mt-10 box pa-10 radius-10"
					:inner-html.prop="item.work_content | nl2br"
				></div>
			</div>

			<div class="mt-10">

				<label class="h6 display-block mt-10 justify-space-between items-center">
					작업 목록

					<button
						v-if="user.member_level >= 3"
						class="btn btn-primary"

						@click="toTask"
					>작업 등록</button>
				</label>

				<div class="mt-10">
					<ul
						v-if="items_task.length > 0"
					>
						<template
							v-for="task in items_task"
						>
							<li
								:key="task.uid"
								class="box radius-10 pa-10 mt-10 justify-space-between gap-10 items-center cursor-pointer"
								:class="{'box-primary':task.status == '1'  }"

								@click="toTaskView(task)"
							>
								{{ task.task_name }}
							</li>
						</template>
					</ul>
					<Empty
						v-else
					></Empty>
				</div>
			</div>

			<div
				v-if="user.member_level >= 2"
				class="mt-10"
			>

				<label class="h6 display-block mt-10">
					현장 관리 인원
				</label>

				<div>
					<ul>
						<template
							v-for="member in items_member"
						>
							<li
								v-if="member.status == '1'"
								:key="member.member_id"
								class="box radius-10 pa-10 mt-10 justify-space-between gap-10 items-center"
								:class="{'box-primary':member.status == '1'  }"
							>
								{{ member.member_name }} ( {{ member.member_id }} )
							</li>
						</template>
					</ul>
				</div>
			</div>
		</div>
		<div
			v-if="user.member_level >= 3"
			class="mt-auto"
		>
			<button
				class="btn-full btn-primary"
				@click="toDetail"
			>정보수정 및 관리 인원 배정</button>
		</div>
	</div>
</template>

<script>

import Empty from "../Layout/Empty";
export default {
	name: 'ProjectWorkView'
	,
	components: {Empty},
	props: ['user']
	, data: function(){
		return {
			program: {
				name: '업무 상세 정보'
				, not_top: true
				, title: true
				, bottom: false
				, is_container: true
			}
			, item: {
				work_content: ''
			}
			, work_idx: this.$route.params.idx
			, items_member: []
			, items_task: []
		}
	}
	, methods: {
		getData: async function(){
			this.$bus.$emit('on', true)
			try {
				const result = await this.$request.init({
					method: 'get'
					, url: 'project/getProjectWork'
					, data: {
						idx: this.work_idx
					}
				})

				if(result.success){
					this.item = result.data.work_info
					this.items_member = result.data.member_list
					this.items_task = result.data.task_list
					this.$bus.$emit('notify', { type: 'success', message: result.message})
				}else{
					throw result.message
				}
			}catch (e){
				this.$bus.$emit('notify', { type: 'error', message: e})
			}finally {
				this.$bus.$emit('on', false)
			}
		}
		, toDetail: function (){
			this.$bus.$emit('to', {name: 'ProjectWorkDetail', params: { idx: this.work_idx}})
		}
		, toTask: function(){
			this.$bus.$emit('to', {name: 'ProjectTask', params: { idx: this.work_idx}})
		}
		, toTaskView: function(task){
			this.$bus.$emit('to', {name: 'ProjectTaskView', params: { idx: task.uid}})
		}
	}
	, created() {
		this.$bus.$emit('onLoad', this.program)
		this.getData()
	}
}
</script>